import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { ClipboardList } from "lucide-react";
import VibratingButton from "@/components/base/button/VibratingButton";
import IconChevron from "@/assets/icons/chevron.svg?react";
import { SurveyListItem } from "@/pages/profile/surveys/surveys.types";

type Props = {
  survey: SurveyListItem;
};

// Home check-in slider'idagi survey slide. Stil DailyCheckIn kartasiga
// 1:1 mos (bg-white/08 rounded-xl, bir xil balandlik) — bosilganda
// survey sahifasini ochadi.
export default function HomeSurveyCard({ survey }: Props) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <VibratingButton
      className="w-full text-start"
      onClick={() => navigate(`/profile/surveys/${survey.id}`)}
    >
      <div className="py-2.5 px-3 bg-white/08 rounded-xl border-b border-white/08 flex items-center gap-3">
        <div className="size-11 rounded-full bg-orange-100/15 border border-orange-100/20 flex-center shrink-0">
          <ClipboardList className="size-5 text-orange-100" />
        </div>
        <div className="flex flex-col gap-1 flex-1 min-w-0">
          <p className="text-base font-semibold leading-130 text-white truncate">
            {survey.title}
          </p>
          <p className="text-small leading-130 text-gray-1 truncate">
            {t("survey_fill_now") || "So'rovnomani to'ldiring"}
          </p>
        </div>
        {/* DON reward (icon + miqdor) home kartada ko'rsatilmaydi —
            bu ma'lumot survey sahifasining ichida beriladi. */}
        {/* Doira ichidagi chevron — Profil SurveyCard bilan bir xil til:
            nozik fon + bosilganda feedback (qoraytirish + scale). */}
        <span className="size-8 rounded-full bg-white/[0.06] flex-center shrink-0 active:bg-white/[0.14] active:scale-95 transition-all duration-150">
          <IconChevron className="size-5 text-gray-1" strokeWidth="1.5" />
        </span>
      </div>
    </VibratingButton>
  );
}
